import React, { createContext, useContext, useState } from 'react';

const PermissionContext = createContext();

export const usePermissions = () => {
    return useContext(PermissionContext);
};

export const PermissionProvider = ({ children }) => {
    const [getPermissions, setPermissions] = useState([]);

    const updatePermissions = (newPermissions) => {
        setPermissions(newPermissions);
    };

    return (
        <PermissionContext.Provider value={{ getPermissions, updatePermissions }}>
            {children}
        </PermissionContext.Provider>
    );
};
